
<div class="rate-container" [class.rate-highlight]="rate.rate.bookingCode" [class.has-tag]="rate.rate.isLastMinute || rate.rate.isNonRef">

    @if (rate.rate.bookingCode) {
        <div class="room-booking-code-tag">{{'av.roomHasBookingCode'|translate}} <span class="room-booking-code-name">{{rate.rate.bookingCode}}</span></div>
    }
    @if (rate.rate.isNonRef) {
        <div class="room-annotation-tag">{{'av.nonRefundableRate'|translate}}</div>
    }
    @else if (rate.rate.isLastMinute) {
        <div class="room-annotation-tag">{{'av.lastMinuteRate'|translate}}</div>
    }

    <div class="row">
        <div class="col-12 col-lg-7 col-xxl-8 rate-texts">
            <h4 class="rate-name">{{rate|formatRateName}}</h4>
            <app-truncated-text [text]="rate?.rate?.pim?.rateDescription || rate.rate.rateDescription" [truncateHeight]="truncateHeight"></app-truncated-text>
            <div class="rate-cancel-policy" [innerHTML]="rate?.rate?.pim?.cancellationPolicy"></div>
        </div>
        <div class="col-12 col-lg-5 col-xxl-4 rate-actions">
            <div class="row">
                <div class="col-7 col-lg-12 rate-price-col">
                    
                    <div class="rate-price" [attr.data-testid]="'rate-price'">
                        @if (settings.get("availability.showOriginalPriceIfDiscount") && rate.totalOriginalPrice > rate.totalPriceForStayWithTaxes) {
                            <div class="rate-original-price" [innerHTML]="rate.totalOriginalPrice|displayPrice" [attr.data-testid]="'rate-original-price'"></div>
                        }
                        <span  [innerHTML]="rate.totalPriceForStayWithTaxes|displayPrice"></span>
                    </div>
                </div>
                <div class="col-5 col-lg-12">
                    <p-button class="w-100" (click)="selectRate($event)" [attr.data-testid]="'select-rate'">
                        {{"av.Select"|translate}}
                        @if (rate.rate.membershipTier) {
                            <span class="material-symbols-outlined" [pTooltip]="'av.memberRate'|translate">
                                vpn_key
                            </span>

                        }
                    </p-button>
                </div>
            </div>
        </div>
        <app-availability-debugview [rate]="rate"></app-availability-debugview>
    </div>
</div>
